import { shouldUseBottomNavShell } from "@/navigation/bottomNavEligibility";
/** Rutas de autenticación / onboarding donde nunca debe mostrarse el bottom nav. */
export const AUTH_SHELL_ROUTE_NAMES = new Set([
    "login",
    "register",
    "password-recovery",
    "magic-link",
    "callback",
    "validar-qr",
    "legal-terms",
    "legal-privacy",
    "agregar-apoderado-curso",
    "agregar-usuario-grupo",
    "agregar-directivas-colegio",
    "convivencia-asistencia",
]);
export const routeHidesBottomNav = (route) => {
    if (route.meta?.hideBottomNav)
        return true;
    if (route.matched.some((record) => record.meta?.hideBottomNav))
        return true;
    const name = typeof route.name === "string" ? route.name : "";
    if (AUTH_SHELL_ROUTE_NAMES.has(name))
        return true;
    return false;
};
export const shouldShowBottomNavigation = (route, curso, userEmail, isAuthenticated) => {
    if (!isAuthenticated)
        return false;
    if (routeHidesBottomNav(route))
        return false;
    return shouldUseBottomNavShell(curso, userEmail);
};
/** Evita reanudar en una sección sin curso cargado (p. ej. Yo sin bottom nav). */
export const resolveAuthenticatedResumeRoute = (lastRoute, hasCurso) => {
    const fallback = "/user/main-view";
    const normalized = String(lastRoute ?? "").trim();
    if (!normalized)
        return fallback;
    if (!hasCurso &&
        normalized.startsWith("/user/") &&
        normalized !== fallback) {
        return fallback;
    }
    return normalized;
};
